module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sc-8357ba15f90dbaaeec2a8b5ab44fdfad.svg";